module.exports = __webpack_public_path__ + "static/media/shedpaper.d13a3dde.jpg";